<template>
  <div class="mylistings-cardlist-wrapper pos-relative">
    <Row :gutter="20" class="padding-t-20" v-if="myListings && myListings.length > 0">
      <i-col :xs="24" :sm="12" :md="8" v-for="(item, idx) in myListings" :key="idx">
        <Card style="margin-top:20px;">
          <div class="info-con text-center">
            <div class="k-avatar pos-relative" style="border:1px solid #404040;margin:20px auto; 0px auto;">
              <Avatar  v-if="item.logo" :src="item.logo" size="50"/>
              <img v-else src="~@/assets/images/logo/default-company-logo.png" alt="kromnix logo" width="100%" class="centered">
            </div>
            <h3 class="padding-b-20">{{ item.name }}</h3>
            <Button icon="md-create" class="k-btn-2" size="small" @click="handleEditMyListing(item.slug)" style="margin-right:20px">Edit</Button>
            <Button icon="md-eye" class="k-btn-5" size="small" @click="handleTechProviderPage(item.slug)" :disabled="item.status == 'pending'">View listing online</Button>
          </div>
          <Row type="flex" justify="space-between" class="padding-t-20">
            <i-col :xs="24" :sm="12">Created : {{ item.created_date | formatDate }}</i-col>
            <i-col :xs="24" :sm="12" class="text-right">Expires : {{ item.expiry_date | formatDate }}</i-col>
          </Row>
        </Card>
      </i-col>
    </Row>
    <NoData v-else message="You do not have any active listings" class="centered"/>
  </div>
</template>

<script>
import moment from 'moment'
import NoData from '@/components/ui/NoData'

export default {
  props: {
    myListings: {
      type: Array,
      default: () => []
    }
  },

  filters: {
    formatDate (date) {
      if (date) {
        return moment(date).format('ll')
      } else {
        return '-'
      }
    }
  },

  data () {
    return {
      backendBaseUrl: process.env.VUE_APP_URL
    }
  },

  components: {
    NoData
  },

  methods: {
    handleEditMyListing (slug) {
      this.$router.push(
        {
          name: 'my-listing-form',
          query: { name: slug }
        }
      )
    },

    handleTechProviderPage (slug) {
      const routeData = this.$router.resolve({
        name: 'company',
        params: {
          slug: slug
        },
        query: {}
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.mylistings-cardlist-wrapper {
  height: calc( 100% - 150px);
}
</style>
